// 3rd party
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'format' })
export class FormatPipe implements PipeTransform {
  transform(value: any, args: string): any {
    // tslint:disable-next-line:triple-equals
    if (args == 'date') {
      return new Date(value).toLocaleDateString();
    } else {
      return value;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/format.pipe.ts